export type Language = "EN" | "ES" | "FR";

export const services = [
  "Nursing Triage",
  "Weight Management",
  "HIV Test",
  "Blood Sugar Check",
  "Blood Pressure Check",
  "Physical Therapy / Pain Management",
  "Cholesterol Check",
  "Massage",
  "Vision and Hearing",
  "Medication Management",
  "Vascular Screening Ultrasound",
  "Blood Work / EKG",
  "Hepatitis B / C",
  "CPR Training",
  "Health and Wellness",
  "Cancer Screening",
];

export const copy = {
  EN: {
    register: "Register now",
    staff: "Staff portal",
    eyebrow: "Free community health services",
    title: "A healthier community starts with one day together.",
    subtitle: "Free screenings, wellness guidance, family support, food bags, and back-to-school resources — all in one welcoming place.",
    date: "Saturday, August 22, 2026",
    time: "10:00 AM–3:00 PM · Check-in from 9:00 AM",
    location: "Redeemers Church of Christ · 10001 Aerospace Road, Lanham, MD",
    formTitle: "Reserve your place",
    formIntro: "Registration takes about three minutes. Your information is protected and used only to provide event services.",
    profile: "About you",
    services: "Choose services",
    schedule: "Schedule & consent",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone number",
    email: "Email address (optional)",
    dob: "Date of birth",
    sex: "Sex at birth",
    attendeeType: "Attendee type",
    next: "Continue",
    back: "Back",
    submit: "Confirm registration",
    chooseTime: "Preferred check-in time",
    generalConsent: "I consent to registration and the event services I select.",
    emailConsent: "Email me my confirmation, reminders, and health report when available.",
    smsConsent: "Text me event reminders.",
    food: "I am interested in food bag support.",
    school: "I am interested in back-to-school support.",
    success: "You’re registered!",
    qrHelp: "Save this QR code and show it at check-in.",
  },
  ES: {
    register: "Registrarse ahora",
    staff: "Portal del personal",
    eyebrow: "Servicios de salud comunitarios gratuitos",
    title: "Una comunidad más saludable comienza con un día juntos.",
    subtitle: "Exámenes gratuitos, orientación de bienestar, apoyo familiar, bolsas de alimentos y recursos escolares en un lugar acogedor.",
    date: "Sábado, 22 de agosto de 2026",
    time: "10:00 AM–3:00 PM · Registro desde las 9:00 AM",
    location: "Redeemers Church of Christ · 10001 Aerospace Road, Lanham, MD",
    formTitle: "Reserve su lugar",
    formIntro: "El registro toma unos tres minutos. Su información está protegida y se usa solo para los servicios del evento.",
    profile: "Sobre usted",
    services: "Elija servicios",
    schedule: "Horario y consentimiento",
    firstName: "Nombre",
    lastName: "Apellido",
    phone: "Número de teléfono",
    email: "Correo electrónico (opcional)",
    dob: "Fecha de nacimiento",
    sex: "Sexo al nacer",
    attendeeType: "Tipo de asistente",
    next: "Continuar",
    back: "Atrás",
    submit: "Confirmar registro",
    chooseTime: "Hora preferida de llegada",
    generalConsent: "Acepto el registro y los servicios que seleccione.",
    emailConsent: "Envíenme por correo la confirmación, recordatorios y el informe de salud.",
    smsConsent: "Envíenme recordatorios por texto.",
    food: "Me interesa recibir apoyo con alimentos.",
    school: "Me interesa el apoyo de regreso a clases.",
    success: "¡Está registrado!",
    qrHelp: "Guarde este código QR y muéstrelo al registrarse.",
  },
  FR: {
    register: "S’inscrire",
    staff: "Portail du personnel",
    eyebrow: "Services de santé communautaires gratuits",
    title: "Une communauté en meilleure santé commence par une journée ensemble.",
    subtitle: "Dépistages gratuits, conseils de bien-être, soutien familial, sacs alimentaires et fournitures scolaires dans un lieu accueillant.",
    date: "Samedi 22 août 2026",
    time: "10 h–15 h · Accueil à partir de 9 h",
    location: "Redeemers Church of Christ · 10001 Aerospace Road, Lanham, MD",
    formTitle: "Réservez votre place",
    formIntro: "L’inscription prend environ trois minutes. Vos informations sont protégées et utilisées uniquement pour les services de l’événement.",
    profile: "À propos de vous",
    services: "Choisir les services",
    schedule: "Horaire et consentement",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone",
    email: "Adresse courriel (facultatif)",
    dob: "Date de naissance",
    sex: "Sexe à la naissance",
    attendeeType: "Type de participant",
    next: "Continuer",
    back: "Retour",
    submit: "Confirmer l’inscription",
    chooseTime: "Heure d’arrivée souhaitée",
    generalConsent: "Je consens à l’inscription et aux services que je sélectionne.",
    emailConsent: "Envoyez-moi la confirmation, les rappels et mon rapport de santé par courriel.",
    smsConsent: "Envoyez-moi les rappels par texto.",
    food: "Je souhaite recevoir un soutien alimentaire.",
    school: "Je souhaite recevoir des fournitures scolaires.",
    success: "Votre inscription est confirmée !",
    qrHelp: "Enregistrez ce code QR et présentez-le à l’accueil.",
  },
} as const;
